/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface YoutubeVideoConfigInfoRespVo
 */
export interface YoutubeVideoConfigInfoRespVo {
    /**
     * 主键ID
     * @type {number}
     * @memberof YoutubeVideoConfigInfoRespVo
     */
    id?: number;
    /**
     * 缩略图OSS地址
     * @type {string}
     * @memberof YoutubeVideoConfigInfoRespVo
     */
    thumbnailUrl?: string;
    /**
     * YouTube原始完整视频链接
     * @type {string}
     * @memberof YoutubeVideoConfigInfoRespVo
     */
    videoUrl?: string;
    /**
     * YouTube视频ID
     * @type {string}
     * @memberof YoutubeVideoConfigInfoRespVo
     */
    youtubeVideoId?: string;
    /**
     * 视频标题（韩文）
     * @type {string}
     * @memberof YoutubeVideoConfigInfoRespVo
     */
    titleKr?: string;
    /**
     * 视频标题（中文）
     * @type {string}
     * @memberof YoutubeVideoConfigInfoRespVo
     */
    titleCn?: string;
    /**
     * 视频简介（韩文）
     * @type {string}
     * @memberof YoutubeVideoConfigInfoRespVo
     */
    descriptionKr?: string;
    /**
     * 视频简介（中文）
     * @type {string}
     * @memberof YoutubeVideoConfigInfoRespVo
     */
    descriptionCn?: string;
    /**
     * 展示排序，数值越小越靠前；未删除记录中不可重复
     * @type {number}
     * @memberof YoutubeVideoConfigInfoRespVo
     */
    sortNo?: number;
    /**
     * 是否可用：0不可用，1可用
     * @type {number}
     * @memberof YoutubeVideoConfigInfoRespVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof YoutubeVideoConfigInfoRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof YoutubeVideoConfigInfoRespVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the YoutubeVideoConfigInfoRespVo interface.
 */
export function instanceOfYoutubeVideoConfigInfoRespVo(value: object): value is YoutubeVideoConfigInfoRespVo {
    return true;
}

export function YoutubeVideoConfigInfoRespVoFromJSON(json: any): YoutubeVideoConfigInfoRespVo {
    return YoutubeVideoConfigInfoRespVoFromJSONTyped(json, false);
}

export function YoutubeVideoConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): YoutubeVideoConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'videoUrl': json['videoUrl'] == null ? undefined : json['videoUrl'],
        'youtubeVideoId': json['youtubeVideoId'] == null ? undefined : json['youtubeVideoId'],
        'titleKr': json['titleKr'] == null ? undefined : json['titleKr'],
        'titleCn': json['titleCn'] == null ? undefined : json['titleCn'],
        'descriptionKr': json['descriptionKr'] == null ? undefined : json['descriptionKr'],
        'descriptionCn': json['descriptionCn'] == null ? undefined : json['descriptionCn'],
        'sortNo': json['sortNo'] == null ? undefined : json['sortNo'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function YoutubeVideoConfigInfoRespVoToJSON(json: any): YoutubeVideoConfigInfoRespVo {
    return YoutubeVideoConfigInfoRespVoToJSONTyped(json, false);
}

export function YoutubeVideoConfigInfoRespVoToJSONTyped(value?: YoutubeVideoConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'thumbnailUrl': value['thumbnailUrl'],
        'videoUrl': value['videoUrl'],
        'youtubeVideoId': value['youtubeVideoId'],
        'titleKr': value['titleKr'],
        'titleCn': value['titleCn'],
        'descriptionKr': value['descriptionKr'],
        'descriptionCn': value['descriptionCn'],
        'sortNo': value['sortNo'],
        'enable': value['enable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

